import { OffsetDate, OffsetDateProps } from "@/shared/form/offset-date";

export function DynamicAttributeFieldSimpleDate(props: OffsetDateProps) {
  return <OffsetDate allowClear {...props} />;
}
